/**
 * @author       hugo@zumper.com (Hugo Pineda)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { localStorageSingleton } from '@zcode/nr-utils'
import type { PageName } from './types'

const STORAGE_KEY = 'mixpanel_prev_page'

export const clearPreviousPage = () => {
  localStorageSingleton.del(STORAGE_KEY)
}

export const setPreviousPage = (pageName: PageName) => {
  localStorageSingleton.set(STORAGE_KEY, pageName)
}

export const getPreviousPage = () => {
  return localStorageSingleton.get(STORAGE_KEY)
}
